import { render, staticRenderFns } from "./TDSSpinner.vue?vue&type=template&id=5e675b7b&scoped=true"
import script from "./TDSSpinner.vue?vue&type=script&lang=ts"
export * from "./TDSSpinner.vue?vue&type=script&lang=ts"
import style0 from "./TDSSpinner.vue?vue&type=style&index=0&id=5e675b7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e675b7b",
  null
  
)

export default component.exports